export default function tplNewOrder() {
  return {
    name: '',
    email: '',
    phone: '',
    pickup: '2', // Самовывоз из Москвы
    deliveryService: '',
    city: '',
    cityId: '',
    address: '',
    comment: '',
    traderCode: '',
    payment: '1', // Оплата наличными при получении
    post_address: '',
    post_city: '',
    post_cityId: '',
    pvzCode: ''
  };
}
